export function maskPassword(password: string): string {
    if (password.length <= 3) {
        return '*'.repeat(password.length); // Mask entire password if it's 3 chars or less
    }
    if (!password) throw new Error(`Invalid password provided.`);
    const visiblePart = password.slice(-3); // Get the last 3 characters
    const maskedPart = '*'.repeat(password.length - 3); // Mask the rest
    return `${maskedPart}${visiblePart}`;
}